import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto } from '@/Domain/api/Action/dto/Action.dto';
import { ShopifyMcpDto } from '@/Domain/api/Action/dto/ShopifyMcp.dto';
import { ActionTypeEnum } from '@/Domain/enum/ActionType.enum';

// Fetches the actions list (reliable cold-load badge) and reads the Shopify detail passively from cache.
export const useShopifyConnection = () => {
  const { data: actions } = useQuery<ActionDto[]>({
    queryKey: [QueryKey.actions.basic.list],
    staleTime: 5 * 60 * 1000,
  });

  const shopifyAction = (Array.isArray(actions) ? actions : []).find(
    (action) => action.type === ActionTypeEnum.ShopifyRemoteMcp,
  );

  const { data: shopifyDetail } = useQuery<ShopifyMcpDto>({
    queryKey: [QueryKey.actions.shopifyMcp.get, shopifyAction?.id],
    enabled: false,
  });

  const storeUrl = shopifyDetail?.shopify_url || '';
  // Active implies a saved URL (the form requires one to activate), so the list alone
  // is a reliable signal; the URL check only applies when the detail is actually cached.
  const isConnected = Boolean(shopifyAction?.is_active && (shopifyDetail ? storeUrl : true));

  return { shopifyAction, shopifyDetail, isConnected, storeUrl };
};
